export default function ComparisonTabs({ activeTab, onTabChange }) {
  const handleTabClick = (tab) => {
    console.log(`[Sawtna] Nurse selected tab: ${tab}`);
    onTabChange(tab);
  };

  return (
    <div className="flex border-b border-gray-200">
      <button
        type="button"
        onClick={() => handleTabClick('openai')}
        className={`min-h-touch flex-1 px-4 py-3 text-center font-semibold transition-colors ${
          activeTab === 'openai'
            ? 'border-b-2 border-primary text-primary'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        OpenAI
      </button>
      <button
        type="button"
        onClick={() => handleTabClick('corti')}
        className={`min-h-touch flex-1 px-4 py-3 text-center font-semibold transition-colors ${
          activeTab === 'corti'
            ? 'border-b-2 border-primary text-primary'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        Corti
      </button>
    </div>
  );
}
